<template>
    <div>
      <!-- Form Group -->
      <div class="form-group mb-3">
        <label for="level" class="form-label">
          <i class="bi bi-book"></i> Package Type
        </label>
        <input
          type="text"
          id="type"
          v-model="type"
          class="form-control"
          placeholder="Enter Package Type"
          required
        />

        <label for="level" class="form-label">
          <i class="bi bi-book"></i> Duration
        </label>
        <input
          type="duration"
          id="duration"
          v-model="duration"
          class="form-control"
          placeholder="Enter Duration"
          required
        />

        <label for="price" class="form-label">
          <i class="bi bi-book"></i>Package Price For Month
        </label>
        <input
          type="number"
          id="pkg_price_for_month"
          v-model="pkg_price_for_month"
          class="form-control"
          placeholder="Enter Package Price For Month"
          required
        />

        <label for="price" class="form-label">
          <i class="bi bi-book"></i> Package Price
        </label>
        <input
          type="number"
          id="package_price"
          v-model="package_price"
          class="form-control"
          placeholder="Enter Package Price"
          required
        />
        
        <div v-if="errorMessage" class="alert alert-danger mt-2">
          <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
        </div>
        <div v-if="successMessage" class="alert alert-success mt-2">
          <i class="bi bi-check-circle-fill"></i> {{ successMessage }}
        </div>
        <button @click="submitForm" class="btn btn-primary mt-3">
          <i class="bi bi-save"></i> Save
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        type: '',
        duration: '',
        pkg_price_for_month:'',
        package_price:'',
        successMessage: null,
        errorMessage: null,
      };
    },
    methods: {
      async submitForm() {
        this.successMessage = null; // Reset success message
        this.errorMessage = null;   // Reset error message
  
        try {
          const response = await axios.post('/insert-packages', {
            type: this.type,
            duration: this.duration,
            pkg_price_for_month: this.pkg_price_for_month,
            package_price: this.package_price,
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            }
          });
  
          // Handle successful submission
          this.successMessage = response.data.message; // Set the success message
          this.level = ''; // Clear the form
          this.price = ''; // Clear the form
          this.pkg_price_for_month = '';
          this.package_price = '';

        } catch (error) {
          if (error.response && error.response.data) {
            // Handle errors from Laravel
            this.errorMessage = error.response.data.message || 'An error occurred.';
          } else {
            this.errorMessage = 'An error occurred.';
          }
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add any specific styles you need */
  </style>
  